<mat-card appearance="outlined" class="col-12" *ngIf="application">
  <form [formGroup]="emailForm">
    <div class="card-header">
      <mat-card-title class="card-title">
        <div class="flex-title">
          <span class="tab-title">{{ application.name }} Email Templates</span>
          <button mat-stroked-button (click)="viewVariables()" color="accent">View Variables</button>
          <div class="spacer"></div>
          <button mat-raised-button (click)="submit()" [disabled]="emailForm.invalid" color="accent">Save</button>
        </div>
      </mat-card-title>
    </div>

    <mat-card-content>

      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Release Email Subject</mat-label>
            <input matInput placeholder="Release Email Subject" formControlName="release_subject">
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Release Email Subject Preview</mat-label>
            <input matInput placeholder="Release Email Subject Preview" formControlName="release_subject_preview"
              readonly>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div>New Release Email Body Template</div>
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Markdown</mat-label>
            <textarea rows="20" matInput placeholder="release_email" formControlName="release_email"></textarea>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <div>New Release Email Body Preview</div>
          <markdown class="preview" [data]="release_preview"></markdown>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>License Email Subject</mat-label>
            <input matInput placeholder="License Email Subject" formControlName="license_subject">
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>License Email Subject Preview</mat-label>
            <input matInput placeholder="License Email Subject Preview" formControlName="license_subject_preview"
              readonly>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div>New License Email Body Template</div>
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Markdown</mat-label>
            <textarea rows="20" matInput placeholder="license_email" formControlName="license_email"></textarea>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <div>New License Email Body Preview</div>
          <markdown class="preview" [data]="license_preview"></markdown>
        </div>
      </div>

    </mat-card-content>
  </form>
</mat-card>